import { BbxRequest } from "../../data/Request/BbxRequest";
import { Page } from "../../data/Page";
import { ApiRoutes } from "../../routes/ApiRoutes";
import { requestService } from "../../services/RequestService";
import { NotificationListView } from "./view/NotificationListView";
import { NotificationUnreadCountsView } from "./view/NotificationUnreadCountsView";
import { NotificationGroupEnum } from "./constants/NotificationTypeEnum";
import { notificationCountsStore } from "./notificationCountsStore";

export interface NotificationRequestDTO {
    unpaid?: boolean;
    nbrOfDays?: number;
    group?: NotificationGroupEnum;
    companyName?: string;
    vendorId?: string;
}

export const NotificationModelAPI = {
    search: async (req: BbxRequest<NotificationRequestDTO>): Promise<Page<NotificationListView>> => {
        const response = await requestService.post(
            ApiRoutes.REST_API_NOTIFICATION_MODEL_ENDPOINT, req);

        return new Page(NotificationListView, response.data);
    },

    /** Unread counts per group, for the notifications badge of the header. */
    getUnreadCounts: async (): Promise<NotificationUnreadCountsView> => {
        const response = await requestService.get(
            `${ApiRoutes.REST_API_NOTIFICATION_MODEL_ENDPOINT}/unread-counts`);

        return new NotificationUnreadCountsView(response.data);
    },

    /**
     * Clears the unread flag on the whole bucket, which is what empties the matching header badge.
     * The legacy page did this as a side effect of rendering; here it is an explicit call.
     */
    markSeen: async (unpaid: boolean, group?: NotificationGroupEnum | null)
        : Promise<NotificationUnreadCountsView> => {
        const response = await requestService.put(
            `${ApiRoutes.REST_API_NOTIFICATION_MODEL_ENDPOINT}/mark-seen`, null,
            { params: { unpaid, group: group ?? undefined } });

        // The endpoint answers with the refreshed counts, so the badge can drop straight away.
        // Announced here so no caller can forget it.
        const counts = new NotificationUnreadCountsView(response.data);
        notificationCountsStore.notifyChanged(counts);

        return counts;
    },
};
